export const DOMINICA_TIMEZONE = 'America/Dominica'
export const MINUTE_IN_MILLISECONDS = 60000
export const DAY_IN_MILLISECONDS = 86400000
export const WEEK_IN_MILLISECONDS = 604800000

export const SUNDAY = 'sunday'
export const MONDAY = 'monday'
export const TUESDAY = 'tuesday'
export const WEDNESDAY = 'wednesday'
export const THURSDAY = 'thursday'
export const FRIDAY = 'friday'
export const SATURDAY = 'saturday'

export const DAYS_OF_THE_WEEK = [SUNDAY, MONDAY, TUESDAY, WEDNESDAY, THURSDAY, FRIDAY, SATURDAY]

export const DAY_TIME_HOUR_LIST = [
    {id: "00:00", text: "12:00 AM"},
    {id: "00:30", text: "12:30 AM"},
    {id: "01:00", text: "1:00 AM"},
    {id: "01:30", text: "1:30 AM"},
    {id: "02:00", text: "2:00 AM"},
    {id: "02:30", text: "2:30 AM"},
    {id: "03:00", text: "3:00 AM"},
    {id: "03:30", text: "3:30 AM"},
    {id: "04:00", text: "4:00 AM"},
    {id: "04:30", text: "4:30 AM"},
    {id: "05:00", text: "5:00 AM"},
    {id: "05:30", text: "5:30 AM"},
    {id: "06:00", text: "6:00 AM"},
    {id: "06:30", text: "6:30 AM"},
    {id: "07:00", text: "7:00 AM"},
    {id: "07:30", text: "7:30 AM"},
    {id: "08:00", text: "8:00 AM"},
    {id: "08:30", text: "8:30 AM"},
    {id: "09:00", text: "9:00 AM"},
    {id: "09:30", text: "9:30 AM"},
    {id: "10:00", text: "10:00 AM"},
    {id: "10:30", text: "10:30 AM"},
    {id: "11:00", text: "11:00 AM"},
    {id: "11:30", text: "11:30 AM"},
    {id: "12:00", text: "12:00 PM"},
    {id: "12:30", text: "12:30 PM"},
    {id: "13:00", text: "1:00 PM"},
    {id: "13:30", text: "1:30 PM"},
    {id: "14:00", text: "2:00 PM"},
    {id: "14:30", text: "2:30 PM"},
    {id: "15:00", text: "3:00 PM"},
    {id: "15:30", text: "3:30 PM"},
    {id: "16:00", text: "4:00 PM"},
    {id: "16:30", text: "4:30 PM"},
    {id: "17:00", text: "5:00 PM"},
    {id: "17:30", text: "5:30 PM"},
    {id: "18:00", text: "6:00 PM"},
    {id: "18:30", text: "6:30 PM"},
    {id: "19:00", text: "7:00 PM"},
    {id: "19:30", text: "7:30 PM"},
    {id: "20:00", text: "8:00 PM"},
    {id: "20:30", text: "8:30 PM"},
    {id: "21:00", text: "9:00 PM"},
    {id: "21:30", text: "9:30 PM"},
    {id: "22:00", text: "10:00 PM"},
    {id: "22:30", text: "10:30 PM"},
    {id: "23:00", text: "11:00 PM"},
    {id: "23:30", text: "11:30 PM"},
    {id: "23:59", text: "11:59 PM"},
 ]